import axios from "axios";
import React, { useState, useEffect } from "react";
import ReactPaginate from "react-paginate";
import { useParams } from "react-router-dom";
import CardTopDetailed from "../../shared/component/card/CardTopDetailed";

interface BeritaItem {
  id: number;
  judul: string;
  jenis: string;
  artikel_thumbnail?: string;
}

interface BeritaResponse {
  berita: {
    total: number;
    per_page: number;
    path: string;
    data: BeritaItem[];
  };
  total: number;
  per_page: number;
  path: string;
  data: BeritaItem[];
}

const BeritaContent: React.FC = () => {
  let { search } = useParams<{ search?: string }>();
  const [items, setItems] = useState<BeritaItem[]>([]);
  const [urlpath, setUrlpath] = useState<string>("");
  const [pageCount, setPageCount] = useState<number>(0);

  useEffect(() => {
    const fetchData = async () => {
      const url = search
        ? `https://divhubinter.polri.go.id/api/dhi_search/${search}`
        : `https://divhubinter.polri.go.id/api/dhi_view_berita?page=1`;

      const res = await axios.get<BeritaResponse>(url);
      const data = search ? res.data : res.data.berita;

      setPageCount(Math.ceil(data.total / data.per_page));
      setUrlpath(data.path);
      setItems(data.data);
    };

    fetchData();
  }, [search]);

  const fetchComments = async (currentPage: number) => {
    const url = `${urlpath}?page=${currentPage}`;
    const res = await axios.get<BeritaResponse>(url);
    const data = search ? res.data.data : res.data.berita.data;
    setItems(data);
    return data;
  };

  const handlePageClick = async (data: { selected: number }) => {
    const currentPage = data.selected + 1;
    await fetchComments(currentPage);
  };

  return (
    <div className="mx-auto w-11/12 laptop:max-w-full desktop:max-w-7xl ">
      <div className="laptop:grid py-12">
        <h2 className="text-4xl font-bold text-left uppercase pb-8">Berita</h2>
        <div className="laptop:grid laptop:grid-cols-3 gap-8">
          {items.map((item) => (
            <CardTopDetailed
              key={item.id}
              image={
                item.artikel_thumbnail
                  ? `https://divhubinter.polri.go.id/${item.artikel_thumbnail}`
                  : undefined
              }
              title={item.judul}
              type={item.jenis}
              link={`/newsdetail/${item.id}`}
            />
          ))}
        </div>
        <br />
        <br />
        <ReactPaginate
          className={"flex justify-center space-x-2"}
          previousLabel="&laquo;"
          nextLabel="&raquo;"
          breakLabel={"..."}
          pageCount={pageCount}
          marginPagesDisplayed={2}
          pageRangeDisplayed={3}
          onPageChange={handlePageClick}
          containerClassName={"btn-group "}
          pageClassName={"btn rounded-none "}
          previousClassName={"join-item btn btn-outline "}
          nextClassName={"join-item btn btn-outline"}
          breakClassName={"btn btn-disabled"}
          activeClassName={"btn-active"}
        />
      </div>
    </div>
  );
};

export default BeritaContent;
